const storage = window && window.localStorage;
export const get = (key) => JSON.parse(storage.getItem(key));
export const upsert = (key, obj) => storage.setItem(key, JSON.stringify(obj));
